export default {
  sections: {
    title: {
      title: 'Bestellung bestätigt',
      description: 'Du hast deinen Geschenkgutschein erfolgreich gekauft',
    },
    instructions: {
      title: 'Prüfe deine E-Mails',
      description:
        'Wir haben dir die Details zu deinem Geschenkgutschein und die Quittung per E-Mail geschickt. Der Gutscheincode sollte innerhalb von 5–10 Minuten bei dir ankommen.',
    },
    details: {
      total: 'Gesamtbetrag',
      order_number: 'Bestellnummer',
    },
    footer: {
      help: 'Unser Technikpartner Foodamigos hilft uns bei der Verwaltung der Geschenkgutscheine. Falls du den Gutschein nicht erhalten hast oder ihn nicht finden kannst, kontaktiere sie bitte unter {{email}}.',
      questions: 'Bei allgemeinen Fragen zur Einlösung kontaktiere uns bitte direkt unter {{email}}.',
    },
  },
  buttons: {
    go_home: 'Zur Startseite',
    download_pdfs: 'Gutschein PDF herunterladen',
  },
};
